import type { Ruleset } from '@ic/engine';

// Rulesets are shared as compressed JSON inside the URL, so links also work offline.

const b64url = (b: Uint8Array) => {
  let s = '';
  for (const x of b) s += String.fromCharCode(x);
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};
const unb64url = (s: string) => Uint8Array.from(atob(s.replace(/-/g, '+').replace(/_/g, '/')), (c) => c.charCodeAt(0));

async function pipe(data: Uint8Array, stream: CompressionStream | DecompressionStream): Promise<Uint8Array> {
  const out = new Response(new Blob([data as BlobPart]).stream().pipeThrough(stream));
  return new Uint8Array(await out.arrayBuffer());
}

export async function encodeRuleset(rs: Ruleset): Promise<string> {
  const raw = new TextEncoder().encode(JSON.stringify(rs));
  return b64url(await pipe(raw, new CompressionStream('deflate-raw')));
}

export async function decodeRuleset(code: string): Promise<Ruleset> {
  const raw = await pipe(unb64url(code), new DecompressionStream('deflate-raw'));
  const rs = JSON.parse(new TextDecoder().decode(raw)) as Ruleset;
  if (rs.schema !== 1 || !rs.board || !rs.pieces) throw new Error('Not a ruleset');
  return rs;
}

export async function shareLink(rs: Ruleset): Promise<string> {
  return `${location.origin}/editor#rs=${await encodeRuleset(rs)}`;
}
